"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneError = exports.REVERSE_QTY_LOW_THAN_MIN = exports.TRADE_CHANGE_ISOLATE_LEVERAGE = exports.TRADE_CHANGED_MARGIN_TYPE_FAILURE = exports.TRADE_CHANGED_POSITION_MODE_FAILURE = exports.TRADE_CHANGED_LEVERAGED_HAS_ACTIVE_ORDERS = exports.TRADE_CHANGED_LEVERAGED_HIGH_POSITION_VALUE = exports.TRADE_CHANGED_LEVERAGED_LOW_MARGIN = exports.TRADE_NOT_HAVE_LEVERAGED_CONFIG = exports.TRADE_LEVERAGED_ACCOUNT_LIMIT = exports.TRADE_LEVERAGED_TOTAL_QUOTA = exports.TRADE_SL_RATE_TOO_HIGH = exports.TRADE_SL_RATE_TOO_LOW = exports.TRADE_TP_RATE_TOO_HIGH = exports.TRADE_TP_RATE_TOO_LOW = exports.TRADE_NOTIONAL_EXCEED = exports.TRADE_LIMIT_LT_TRIGGER = exports.TRADE_LIMIT_GT_TRIGGER = exports.TRADE_AVAILABLE_NOT_ENOUGH = exports.TRADE_MULTI_GT_MAX_CAN_BUY = exports.TRADE_MULTI_LT_MIN_INVEST = exports.TRADE_MULTI_ROW_ERROR = exports.TRADE_MULTI_BOTTOM_GT_HIGHT = exports.TRADE_MULTI_MISSING_PARAMS = exports.CLOSE_POSITION_MORE_THAN_CAN_BUY = exports.TRADE_VALUE_MORE_THAN_CAN_BUY = exports.TRADE_NO_VALUE = exports.TRADE_SYMBOL_INFO_NONE = exports.TRADE_TRIGGER_PRICE_NONE = exports.TRADE_NOTIONAL_NEED_LOWER_LEVERAGE_ROW = exports.TRADE_NO_LEVERAGE_ROW = exports.TRADE_LIMIT_POST_PRICE_LOW = exports.TRADE_LIMIT_POST_PRICE_HIGH = exports.TRADE_DISABLE_OF_LIQUIDATION = exports.TRADE_INVEST_MORE_THAN_CAN_BUY = exports.TRADE_FUTURES_AVAILABLE_NOT_ENOUGH = exports.TRADE_NO_AVAILABLE = exports.TRADE_LIMIT_PRICE_LOW = exports.TRADE_LIMIT_PRICE_HIGH = exports.TRADE_QUOTE_HIGH_THAN_MAX = exports.TRADE_QUOTE_LOW_THAN_MIN = exports.TRADE_QTY_HIGH_THAN_MAX = exports.TRADE_QTY_LOW_THAN_MIN = exports.TRADE_NO_INVEST = exports.TRADE_NO_LIMIT_PRICE = exports.TRADE_NO_CURRENT_PRICE = void 0;
exports.TRADE_NO_CURRENT_PRICE = { code: "0025000000", message: "local: current price is null" };
exports.TRADE_NO_LIMIT_PRICE = { code: "0025000001", message: "local: limit price is null" };
exports.TRADE_NO_INVEST = { code: "0025000002", message: "local: invest is null" };
exports.TRADE_QTY_LOW_THAN_MIN = { code: "0025000004", message: "local: qty low than {min}", data: { min: "--" } };
exports.TRADE_QTY_HIGH_THAN_MAX = { code: "0025000005", message: "local: qty more than max" };
exports.TRADE_QUOTE_LOW_THAN_MIN = { code: "0025000006", message: "local: quote low than {min}", data: { min: "--" } };
exports.TRADE_QUOTE_HIGH_THAN_MAX = { code: "0025000007", message: "local: cost more than max" };
exports.TRADE_LIMIT_PRICE_HIGH = { code: "0025000008", message: "local: limit price too high" };
exports.TRADE_LIMIT_PRICE_LOW = { code: "0025000009", message: "local: limit price too low" };
exports.TRADE_NO_AVAILABLE = { code: "0025000010", message: "local: no available balance" };
exports.TRADE_FUTURES_AVAILABLE_NOT_ENOUGH = { code: "0025000011", message: "local: futures available balance not enough" };
exports.TRADE_INVEST_MORE_THAN_CAN_BUY = { code: "0025000012", message: "local: Invest more than can buy" };
exports.TRADE_DISABLE_OF_LIQUIDATION = {
    code: "0025000013",
    message: "local: Trade is disabled because account is in liquidating state",
};
exports.TRADE_LIMIT_POST_PRICE_HIGH = { code: "0025000014", message: "local: limit price need lower than current price" };
exports.TRADE_LIMIT_POST_PRICE_LOW = { code: "0025000015", message: "local: limit price need higher than current price" };
exports.TRADE_NO_LEVERAGE_ROW = { code: "0025000016", message: "local: 未获取到该杠杆倍数的杠杆配置信息" };
exports.TRADE_NOTIONAL_NEED_LOWER_LEVERAGE_ROW = { code: "0025000017", message: "local: 交易后仓位价值大于最大名义价值" };
exports.TRADE_TRIGGER_PRICE_NONE = { code: "0025000018", message: "local: 请输入触发价" };
exports.TRADE_SYMBOL_INFO_NONE = { code: "0025000019", message: "local: SymbolInfo is none" };
exports.TRADE_NO_VALUE = { code: "0025000020", message: "local: value is null" };
exports.TRADE_VALUE_MORE_THAN_CAN_BUY = { code: "0025000021", message: "local: value is more than can buy" };
exports.CLOSE_POSITION_MORE_THAN_CAN_BUY = { code: "0025000022", message: "local: 可平仓位超过上限" };
// 合约分仓买卖相关错误
exports.TRADE_MULTI_MISSING_PARAMS = { code: "0025000023", message: "缺少分仓买卖的参数" };
exports.TRADE_MULTI_BOTTOM_GT_HIGHT = { code: "0025000024", message: "分仓买卖上下限设置异常" };
exports.TRADE_MULTI_ROW_ERROR = {
    code: "0025000025",
    message: "分仓订单数量不得少于{min}，不得大于{max}",
    data: { min: "--", max: "--" },
};
exports.TRADE_MULTI_LT_MIN_INVEST = { code: "0025000026", message: "分仓小于最小的下单量{amount}", data: { amount: "--" } };
exports.TRADE_MULTI_GT_MAX_CAN_BUY = { code: "0025000027", message: "分仓大于最大可买" };
exports.TRADE_AVAILABLE_NOT_ENOUGH = { code: "0025000028", message: "local: futures available balance not enough" };
exports.TRADE_LIMIT_GT_TRIGGER = { code: "0025000029", message: "限价不能高于 {price}" };
exports.TRADE_LIMIT_LT_TRIGGER = { code: "0025000030", message: "限价不能低于 {price}" };
exports.TRADE_NOTIONAL_EXCEED = {
    code: "0025000031",
    message: "local: 您在{base}/{quote}永续合约下持有的仓位将超过当前杠杆倍数允许的最大持仓价值 {limit} {quote}，请调低杠杆后重新下单(当前杠杆: {leverage}x)",
    data: {
        base: "xxx",
        quote: "xxx",
        leverage: 5,
        limit: "xxx",
    },
};
exports.TRADE_TP_RATE_TOO_LOW = {
    code: "0025000032",
    message: "local: 止盈利润率需高于{value}",
    data: {
        value: "0%",
    },
};
exports.TRADE_TP_RATE_TOO_HIGH = {
    code: "0025000033",
    message: "local: 止盈利润率需低于{value}",
    data: {
        value: "0%",
    },
};
exports.TRADE_SL_RATE_TOO_LOW = {
    code: "0025000034",
    message: "local: 止损利润率需搞于{value}",
    data: {
        value: "0%",
    },
};
exports.TRADE_SL_RATE_TOO_HIGH = {
    code: "0025000035",
    message: "local: 止损利润率需低于{value}",
    data: {
        value: "0%",
    },
};
exports.TRADE_LEVERAGED_TOTAL_QUOTA = {
    code: "0025100001",
    message: "The amount of leverage token you bought exceeds the remaining quota, which is {quota}. Please reduce order quantity.",
    data: {
        quota: "--",
    },
};
exports.TRADE_LEVERAGED_ACCOUNT_LIMIT = {
    code: "0025100002",
    message: "The maximum manual holding amount of this leverage token is {quota}. Please reduce order quantity or switch to other leverage tokens.",
    data: {
        quota: "--",
    },
};
exports.TRADE_NOT_HAVE_LEVERAGED_CONFIG = {
    code: "0025100003",
    message: "没有找到该币种对应的杠杆配置信息",
    data: {
        quota: "--",
    },
};
exports.TRADE_CHANGED_LEVERAGED_LOW_MARGIN = {
    code: "0025100004",
    message: "可用保证金不足",
};
exports.TRADE_CHANGED_LEVERAGED_HIGH_POSITION_VALUE = {
    code: "0025100005",
    message: "当前仓位价值大于目标杠杆倍数所限制的最大仓位价值",
};
exports.TRADE_CHANGED_LEVERAGED_HAS_ACTIVE_ORDERS = {
    code: "0025100006",
    message: "当前币对存在委托订单, 无法修改杠杆倍数, 请撤销委托订单后再修改",
};
exports.TRADE_CHANGED_POSITION_MODE_FAILURE = {
    code: "0025100007",
    message: "设置失败，请先关闭您的持仓并撤销所有挂单",
};
exports.TRADE_CHANGED_MARGIN_TYPE_FAILURE = {
    code: "0025100008",
    message: "设置保证金模式失败，请先关闭{symbolName}的持仓并撤销所有{symbolName}的挂单",
    data: {
        symbolName: "--",
    },
};
/**逐仓模式，不能调低杠杆 */
exports.TRADE_CHANGE_ISOLATE_LEVERAGE = {
    code: "0025100009",
    message: "逐仓仓位暂不支持调低杠杆",
};
exports.REVERSE_QTY_LOW_THAN_MIN = {
    code: "0025100010",
    message: "反手后的下单量小于最小下单量{min}, 无法进行反手",
    data: {
        min: "--",
    },
};
/**基于传入的错误常量，生成一个新的错误，避免多个地方使用同一个常量导致data被覆盖的问题 */
function cloneError(source, data) {
    return Object.assign(Object.assign({}, source), { data });
}
exports.cloneError = cloneError;
